import {useMemo} from 'react';
import {useGetRequestAutoAbortPaginated} from "../../request/useGetRequestAutoAbortPaginated";
import {supplierInterchangesReportEndpoints} from "../../../requests/api-endpoints";
import {SortDirType} from "../../../types/common/SortDirType";
import { SupplierInterchangeSortByType } from '../../../components/interchanges/supplier/filter/SupplierInterchangeSortSelect';
import { InventoryActivityReportViewVO } from '../../../types/model/valueObject/InventoryActivityReportViewVO';

interface UseSupplierInterchanges {
  page?: number | string;
  size?: number | string;
  locationId?: string;
  buyerId?: string;
  startDate?: string;
  endDate?: string;
  equipmentNumber?: string;
  booking?: string;
  driverName?: string;
  assetType: string;
  activity: string;
  sortBy?: SupplierInterchangeSortByType;
  sortDir?: SortDirType;
  doRequest?: () => void;
}

const useSupplierInterchanges = ({ page, size, locationId, buyerId, startDate, endDate, equipmentNumber, booking, driverName, assetType, activity, sortBy, sortDir }: UseSupplierInterchanges) => {
  const queryParams = useMemo(() => ({
    page,
    size,
    locationId,
    buyerId,
    startDate,
    endDate,
    equipmentNumber,
    bookingNumber: booking,
    driverName,
    equipmentType: assetType,
    activity,
    sortBy,
    sortDir,
  }), [page, size, locationId, buyerId, startDate, endDate, equipmentNumber, booking, driverName, assetType, activity, sortBy, sortDir]);

  const {
    responseContent: interchanges,
    pageInfo,
    isLoading,
    error,
    doRequest
  } = useGetRequestAutoAbortPaginated<InventoryActivityReportViewVO[]>({ requestUrl: supplierInterchangesReportEndpoints.search, queryParams });

  return {
    interchanges,
    pageInfo,
    isLoading,
    error,
    doRequest
  }
}

export { useSupplierInterchanges };
